import { render, staticRenderFns } from "./ConversaButton.vue?vue&type=template&id=61826b97&lang=pug&"
import script from "./ConversaButton.vue?vue&type=script&lang=js&"
export * from "./ConversaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports